import Vue from "vue"
import App from "./views/App.vue"
import router from "./router"
import store from "./store"
import "@/permission" // permission control
import "@/styles/index.scss"
import ScrollAnimate from "@/directives/scroll-animate"; // 导入指令
import "animate.css";
import VuePrlx from "vue-prlx"
import VWave from "v-wave"

Vue.directive("scroll-animate", ScrollAnimate); // 全局注册
Vue.use(VuePrlx);
Vue.use(VWave)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: function (h) { return h(App) }
}).$mount("#app")
